export default class Utils {
    static decimalSystem = 10;

    static Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    static rangeOf(N) {
        return Array.apply(null, { length: N }).map(Number.call, Number)
    }

    static dateRenderer(timestamp) {
        if (timestamp === undefined || timestamp === null) {
            return "";
        }

        let utcTimestamp = timestamp + 'Z';
        return new Date(utcTimestamp).toLocaleString();
    }


    static shortDateRenderer(_timestamp, separator = '/') {
        const timestamp = typeof _timestamp === 'string' ? new Date(_timestamp) : _timestamp;
        return timestamp.getFullYear() +
            separator + (timestamp.getMonth() + 1).toString().padStart(2, '0') +
            separator + timestamp.getDate().toString().padStart(2, '0');
    }

    static calibrationFormulaData(data) {
        const defaultData = {
            formula: '-',
            parameters: []
        };
        if (!data) {
            return defaultData;
        }
        const formula = typeof data === 'string' ? data : data.calibrationFormulaType;
        switch (formula) {
            case 'CALPROSMART_FORMULA':
                return {
                    formula: '$Ax^2 + Bx + C $',
                    parameters: ['A', 'B', 'C']
                };
            case 'BLOODTEST_FORMULA':
                return {
                    formula: '$D + \\frac{A-D}{1+(\\frac{x}{C})^B}$',
                    parameters: ['A', 'B', 'C', 'D']
                };
            default:
                return defaultData;
        }
    }
}